// extracted by mini-css-extract-plugin
export default {"header":"newExternalAddress_header__7c8F0","active":"newExternalAddress_active__LxmXt","modal":"newExternalAddress_modal__N6GWC"};